import { Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { ActionButton } from '@tassat/button';
import { APIConnectionRecord } from '@tassat/fred-definitions';
import {
    Contact as ContactIcon,
    Edit as EditIcon,
    Email as EmailIcon,
    Phone as PhoneIcon
} from '@tassat/icon';
import React from 'react';

import { formatEpochDate } from 'Lib/stringHelpers';
import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

interface IAPIConnectionDetails {
    apiConnection: APIConnectionRecord;
    editApiConnection: (apiConnection) => void;
}

const muiStyles = makeStyles((theme: ApplicationMuiTheme) => ({
    root: {
        flexGrow: 1,
        marginTop: '30px',
        color: 'inherit',
        textDecoration: 'inherit'
    },
    underlineTitle: {
        borderBottom: `2px solid ${theme?.app?.applicationColors.enumColors.offWhite ||
        '#F3F3F3'}`,
        fontWeight: 'bold',
        color: theme?.app?.applicationColors.enumColors.grey ||
            '#888888'
    },
    ulStyle: {
        listStyle: 'none',
        fontSize: '.8rem',
        padding: '0',
        marginTop: '5px',
        wordBreak: 'break-all' as const
    },
    editButtonContainer: { padding: '1rem 2rem' }
}));

export const ConnectionDetails = (props: IAPIConnectionDetails) => {
    const {
        apiConnection,
        editApiConnection
    } = props;

    const {
        ClientId,
        ClientSecret,
        EffectiveDate,
        Audience,
        SourceId,
        APIFirmContactName,
        APIFirmEmail,
        APIFirmPhone
    } = apiConnection;

    const {
        root,
        ulStyle,
        underlineTitle,
        editButtonContainer
    } = muiStyles(props);

    return (
        <Grid
            className={root}
            container
            direction='row'
            justifyContent='flex-end'
            spacing={0}
        >
            <Grid
                container
                direction='row'
                item
                justifyContent='space-evenly'
                spacing={3}
                xs={8}
            >
                <Grid
                    container
                    direction='column'
                    item
                    spacing={0}
                    xs={5}
                >
                    <Grid item>
                        <div className={underlineTitle}>
                            Contact name
                        </div>
                        {
                            APIFirmContactName &&
                            <Grid
                                container
                                item
                                spacing={1}
                            >
                                <Grid item>
                                    <ContactIcon id='apiConnectionDetailsContact' />
                                </Grid>
                                <Grid item>
                                    <Typography variant='body2'>
                                        {APIFirmContactName}
                                    </Typography>
                                </Grid>
                            </Grid>
                        }
                        {
                            APIFirmEmail &&
                            <Grid
                                container
                                item
                                spacing={1}
                            >
                                <Grid item>
                                    <EmailIcon id='apiConnectionDetailsEmail' />
                                </Grid>
                                <Grid item>
                                    <Typography variant='body2'>
                                        {APIFirmEmail}
                                    </Typography>
                                </Grid>
                            </Grid>
                        }
                        {
                            APIFirmPhone &&
                            <Grid
                                container
                                item
                                spacing={1}
                            >
                                <Grid item>
                                    <PhoneIcon id='apiConnectionDetailsPhone' />
                                </Grid>
                                <Grid item>
                                    <Typography variant='body2'>
                                        {APIFirmPhone}
                                    </Typography>
                                </Grid>
                            </Grid>
                        }
                    </Grid>
                    <Grid item>
                        <div className={underlineTitle}>
                            Effective Date
                        </div>
                        <ul className={ulStyle}>
                            <li>{formatEpochDate(EffectiveDate, 'MMM Do YY')}</li>
                        </ul>
                    </Grid>
                    <Grid item>
                        <div className={underlineTitle}>
                            Audience
                        </div>
                        <ul className={ulStyle}>
                            <li>{Audience}</li>
                        </ul>
                    </Grid>
                </Grid>
                <Grid
                    container
                    direction='column'
                    item
                    spacing={0}
                    xs={5}
                >
                    <Grid item>
                        <div className={underlineTitle}>
                            Source ID
                        </div>
                        <ul className={ulStyle}>
                            <li>{SourceId}</li>
                        </ul>
                    </Grid>
                    <Grid item>
                        <div className={underlineTitle}>
                            Client ID
                        </div>
                        <ul className={ulStyle}>
                            <li>{ClientId}</li>
                        </ul>
                    </Grid>
                    <Grid item>
                        <div className={underlineTitle}>
                            Client Secret
                        </div>
                        <ul className={ulStyle}>
                            <li>{ClientSecret}</li>
                        </ul>
                    </Grid>
                </Grid>
            </Grid>
            <Grid
                className={editButtonContainer}
                container
                direction='column'
                item
                justifyContent='flex-start'
                spacing={3}
                xs={2}
            >
                <ActionButton
                    handleClick={() => editApiConnection(apiConnection)}
                    Icon={EditIcon}
                    text='Edit'
                    type='icon'
                />
            </Grid>
        </Grid>
    );
};